require('./modeBtns.less');

var Marionette = require('marionette'),
    _ = require('underscore');



module.exports = Marionette.ItemView.extend({

    template: require('./modeBtns.hbs'),

    serializeData: function () {

        var vCh = this.options.vChannel;

        return {
            hideDocMode: !vCh.request('includeDocumentMode', 1),
            hidePgMode: vCh.request('hidePageMode'),
            hidePdfMode: vCh.request('hidePdfMode')
        };

    },
    onRender: function () {
        this.setActiveMode( this.options.vChannel.request('viewMode') );
    },
    ui: {
        modeBtns: '.view-mode'
    },
    events: {

        'click @ui.modeBtns': function(e) {

            e.stopPropagation();

            var selectedMode =  $(e.currentTarget).data('view-mode');
            if (selectedMode === this.options.vChannel.request('viewMode'))
                return;

            this.options.vChannel.command('setViewMode', selectedMode);
        }
    },
    setActiveMode: function(mode) {
        this.ui.modeBtns.removeClass('active');
        this.$('[data-view-mode="' + mode + '"]').addClass('active');
    }

});

 


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/modeBtns/modeBtns.js
 ** module id = 717
 ** module chunks = 0
 **/